export const customIcons: { path: string; label: string }[] = [
  { path: 'assets/icons/warning-outlined.svg', label: 'warning-outlined' },
  { path: 'assets/icons/update-outlined.svg', label: 'update-outlined' },
  { path: 'assets/icons/delete-outlined.svg', label: 'delete-outlined' },
  { path: 'assets/icons/seringue.svg', label: 'seringue' },
];
